import {
  Box,
  List,
  ListItem,
  ListItemText,
  Collapse,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ChevronRightOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import HumbeeLogo from "../TopNav/HumbeeLogo";
import { fetchSubMenu } from "./Reducers/actions";
import { getPWASubMenuAction } from "./API/action";

export default function InnerMenu({ closeDrawer }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState({});
  const { subMenuItems = [] } = useSelector((state) => state?.mainMenuReducer || {});
  useEffect(() => {
    dispatch(fetchSubMenu());
  }, [dispatch]);

  useEffect(() => {
    const expandableItems = _.filter(subMenuItems, { type: "expandable" });
    const initialState = _.fromPairs(
      expandableItems.map((item) => [item.id, true])
    );
    setOpenMenu(initialState);
  }, [subMenuItems]);

  const handleToggle = (id) => {
    setOpenMenu((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <Box sx={{ p: 3, height: "100%", overflowY: "auto" }}>
      <Box sx={{ display: "flex", justifyContent: "center", pt: { xs: 4, lg: 0 } }}>
        <HumbeeLogo />
      </Box>

      <Box sx={{ mt: 2 }}>
        <List>
          {subMenuItems.map((item) => (
            <Box
              key={item.id}
              sx={{ borderBottom: "1px solid #e0e0e0", py: 2 }}
            >
              <ListItem
                button
                onClick={() => {
                  if (item.type === "clickable") {
                    navigate(item.path);
                    closeDrawer?.();
                  } else if (item.type === "expandable") {
                    handleToggle(item.id);
                  }
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    sx: { fontWeight: "bold" },
                  }}
                />
                {item.type === "expandable" ? (
                  openMenu[item.id] ? <ExpandLess /> : <ExpandMore />
                ) : (
                  item.icon ? <img
                  src={item.icon}
                  style={{ width: 20, height: 20 }}
                /> : <ChevronRightOutlined />
                )}
              </ListItem>

              {/* Render children if expandable */}
              {item.type === "expandable" && (
                <Collapse in={openMenu[item.id]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.children.map((child) => (
                      <ListItem
                        key={child.id}
                        button
                        onClick={() => {
                          navigate(child.path);
                          closeDrawer?.();
                        }}
                        sx={{
                          backgroundColor:
                            location.pathname === child.path
                              ? "#F59C1E57"
                              : "transparent",
                          borderRadius: "10px",
                          pl: 3,
                          "&:hover": {
                            backgroundColor:
                              location.pathname === child.path
                                ? "#F59C1E57"
                                : "#f5f5f5",
                          },
                        }}
                      >
                        <img
                          src={
                            location.pathname === child.path
                              ? child.selected_icon || child.icon
                              : child.icon
                          }
                          alt={child.label}
                          style={{ width: 20, height: 20 }}
                        />
                        <ListItemText
                          primary={child.label}
                          primaryTypographyProps={{
                            noWrap: true,
                            sx: {
                              color:
                                location.pathname === child.path
                                  ? "#F59C1E"
                                  : "#9B9B9B",
                              fontWeight: "bold",
                              ml: 2,
                              fontSize: "12px",
                            },
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
}
